import React, { useState, useEffect } from "react";
import {
  useMutation,
  useLazyQuery,
  useApolloClient,
  //useQuery
} from "@apollo/react-hooks";
import {
  Widget,
  addResponseMessage,
  addUserMessage,
  renderCustomComponent,
  toggleMsgLoader,
  //deleteMessages,
  toggleInputDisabled,
  //toggleWidget,
  //toggleWidget,
} from "react-chat-widget-2";
import Linkify from "react-linkify";

import { urlify, checkURL, checkIframe } from "utils/urlUtil";

import queryString from "query-string";
import { CREATE_USER, TALK_TO_BOT, REFRESH_TOKEN } from "mutations";
import { GET_TRANSCRIPT, GET_CLIENT_CONFIG, GET_HASH } from "queries";
import { useAuthToken } from "config/auth";
import "styles/styles.css";
import { Button, Main } from "./elements";
//import toast from "utils/toast";

import useAnalyticsEventTracker from "hooks/useGA";
//import { withLDProvider } from "launchdarkly-react-client-sdk";

const Avatar =
  "https://uploads-ssl.webflow.com/61fefbfa895f2d08b6bdd2ef/620616bb0320710e6e6db686_Cass_Wordmark_SocialMedia_Square_Positive.png";

const Popup = (props) => {
  const client = useApolloClient();
  const gaEventTracker = useAnalyticsEventTracker("Popup Page");

  const [authToken, setAuthToken] = useAuthToken();

  useEffect(() => {
    const { personId } = queryString.parse(props.location.search);
    if (personId) {
      localStorage.setItem("embedUserID", personId);
    }
  }, [props.location.search]);

  const [primaryColor, setColor] = useState("#CECECE"); /* gray */
  const [isBotOn, setBotOn] = useState(true);

  const [botName, setBotName] = useState("Tess");
  const [botAvatar, setAvatar] = useState(Avatar);
  const [chatOpen, setChatOpen] = useState(false);
  const [savedThreadId, setSavedThreadId] = useState(null);
  const [greetingText, setGreeting] = useState(
    'Hi there, say "hi" to start chatting!'
  );

  const [range, setRange] = useState(0);

  const [hidePopup, setHidePopup] = useState(false);

  //const [isMobile, setIsmobile] = useLocalStorage('ismobile', null);
  const { id, clientName } = props.match.params;

  useEffect(() => {
    const { clientName: name } = props.match.params;
    gaEventTracker(`Popup Seen  for client ${name}`, window.location.href);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    gaEventTracker(
      `Popup ready for chat  for client ${clientName}`,
      window.location.href
    );
  }, [clientName, gaEventTracker]);

  const [getTranscript, { refetch, loading: fetchingChats }] = useLazyQuery(
    GET_TRANSCRIPT,
    {
      onCompleted: (data) => {
        toggleInputDisabled();
        const { transcript } = data;
        transcript.map((item) => {
          if (item.fromPerson) {
            return addUserMessage(item.message);
          } else {
            return renderCustomComponent(Message, {
              message: item.message,
              botLoading: botLoading,
            });
            //addResponseMessage(item.message);
          }
        });
      },
      onError: (error) => {
        toggleInputDisabled();
        console.log(error.message);
      },
    }
  );

  const [getHash] = useLazyQuery(GET_HASH, {
    onCompleted: (data) => {
      const { hashId } = data;

      localStorage.setItem("hashId", hashId.idHash);
    },
  });
  const [getToken] = useMutation(REFRESH_TOKEN, {
    onCompleted: (data) => {
      const { generateSessionToken } = data;
      const { sessionTokenExpiry, sessionToken } = generateSessionToken?.person;
      const exp = new Date(sessionTokenExpiry);

      setAuthToken(sessionToken, exp);
    },
  });

  const [createUser, { loading: creatingUser }] = useMutation(CREATE_USER, {
    onCompleted(data) {
      toggleInputDisabled();
      //toggleMsgLoader();
      const createUserObj = data.createPerson && data.createPerson;
      let user = createUserObj && createUserObj.person;
      localStorage.setItem("embedUserID", user && user.personId);
      localStorage.setItem("hashId", user && user.idHash);

      const exp = new Date(user?.sessionTokenExpiry);
      setAuthToken(user?.sessionToken, exp);
      getTranscript({
        variables: {
          personId: user && user.idHash,
          idGreaterThan: 0,
          numberOfRows: 10,
        },
      });
    },
    onError: (error) => {
      toggleInputDisabled();
      toggleMsgLoader();
      console.log(error.message);
    },
  });

  const handleNewUserMessage = (newMessage) => {
    const { threadId, personId, external_org } = queryString.parse(
      props.location.search
    );
    if (newMessage === "CLS_CASS" && localStorage.getItem("hashId")) {
      localStorage.removeItem("hashId");
      localStorage.removeItem("embedUserID");
      window.location.reload();
      return;
    } else if (localStorage.getItem("hashId") && !botLoading) {
      handleClick({
        personId: localStorage.getItem("hashId")
          ? localStorage.getItem("hashId")
          : localStorage.getItem("embedUserID"),
        personMessage: newMessage,
      });
    } else if (!localStorage.getItem("embedUserID") && !personId) {
      createUser({
        variables: {
          clientId: parseInt(id),
          initialThreadId: savedThreadId
            ? savedThreadId
            : parseInt(threadId) || null,
          protocol: "web",
          externalOrg: external_org,
        },
      });
    }
  };

  const [talkToBot, { loading: botLoading }] = useMutation(TALK_TO_BOT, {
    onCompleted: (data) => {
      //toggleInputDisabled();
      toggleMsgLoader();
      const talkToBotObj = data ? data.talkToBot : null;
      if (talkToBotObj.error) {
        return console.log(talkToBotObj.error);
      } else {
        talkToBotObj.response.map((item) => {
          return renderCustomComponent(Message, {
            message: item.string,
            buttons: item.threadButton,
            handleClick: handleClick,
            primaryColor: primaryColor,
            botLoading: botLoading,
          });
          //return addResponseMessage(item.string);
          //const txt = item.string && Parser(urlify(item.string));
        });
      }
      //toggleInputDisabled();
    },
    onError: () => {
      toggleInputDisabled();
      toggleMsgLoader();
    },
  });

  const handleClick = (variables) => {
    toggleMsgLoader();

    talkToBot({ variables: variables })
      .then(() => toggleInputDisabled())
      .catch((error) => {
        return console.log(error.message);
      });

    refetch();
  };

  useEffect(() => {
    const { personId } = queryString.parse(props.location.search);
    personId && localStorage.setItem("embedUserID", personId);
  }, [props.location.search]);

  // useEffect(() => {
  //   const { intro } = queryString.parse(props.location.search);
  //   addResponseMessage(intro);
  //   //toggleWidget();
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  useEffect(() => {
    const { name } = queryString.parse(props.location.search);
    //setColor(`${color.length === 0 ? primaryColor : '#' + color}  `);
    setBotName(`${name.length === 0 ? botName : name}`);

    localStorage.setItem("client", clientName && clientName);
    if (
      localStorage.getItem("embedUserID") &&
      localStorage.getItem("hashId") &&
      clientName !== "neda" &&
      isBotOn
    ) {
      getTranscript({
        variables: {
          personId: localStorage.getItem("hashId"),
          idGreaterThan: 0,
          numberOfRows: 10,
        },
      });
    }
  }, [id, getTranscript, props.location.search, botName, clientName, isBotOn]);

  React.useEffect(() => {
    const hash = localStorage.getItem("hashId");
    const embedUserID = localStorage.getItem("embedUserID");
    if (embedUserID && !hash) {
      getHash({
        variables: {
          personId: embedUserID,
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    const hash = localStorage.getItem("hashId");
    if (hash && !authToken) {
      getToken({
        variables: {
          personId: hash,
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (creatingUser || fetchingChats) {
      return toggleInputDisabled();
      //return addResponseMessage("Typing...", "12121");
    }
  }, [botLoading, creatingUser, fetchingChats]);

  React.useEffect(() => {
    async function getConfig3() {
      try {
        const { data, error } = await client.query({
          query: GET_CLIENT_CONFIG,
          variables: { clientId: id },
          onError() {
            console.log("No Saved config for this client");
          },
        });

        if (!error && data) {
          const dataItems = data?.clientEmbedConfigByClientId;
          const { intro, color, greeting } = queryString.parse(
            props.location.search
          );

          const colorCode = `${
            color.length === 0 ? primaryColor : "#" + color
          }  `;
          const grt = `${
            greeting && greeting.length === 0 ? greetingText : greeting
          }`;

          setColor(dataItems?.themeColor ? dataItems.themeColor : colorCode);
          setGreeting(dataItems?.greeting ? dataItems.greeting : grt);
          addResponseMessage(
            dataItems?.introduction ? dataItems.introduction : intro
          );
          setSavedThreadId(dataItems?.threadId);
          setAvatar(dataItems?.avatar);
          setBotOn(!dataItems?.isQuiesced);
        }
      } catch (error) {
        const { intro, color, greeting, avatar } = queryString.parse(
          props.location.search
        );
        addResponseMessage(intro);
        setColor(`${color.length === 0 ? primaryColor : "#" + color}`);
        setGreeting(
          `${greeting && greeting.length === 0 ? greetingText : greeting}`
        );
        setAvatar(avatar.length === 0 ? Avatar : avatar);
        setBotOn(true);
        console.log("No Saved config for this client");
      }
    }
    getConfig3();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // mutationLoading && toast.info("Creating your account...");

  const getCustomLauncher = (handleToggle) => {
    if (chatOpen) {
      return (
        <button
          className="btn_close"
          onClick={() => {
            handleToggle(false);
            setChatOpen(false);
            window.parent.postMessage("close", "*");
          }}
        >
          <i className="fa fa-close"></i>
        </button>
      );
    } else {
      return (
        <button
          onClick={() => {
            // send a message to the parent window with the click data
            window.parent.postMessage("open", "*");
            handleToggle(true);
            setChatOpen(true);
            gaEventTracker(
              `Popup bubble clicked  for client ${clientName}`,
              window.location.href
            );
          }}
          className="button"
          tooltip={greetingText}
          flow="left"
        >
          <div className="botImage">
            <img src={botAvatar} alt="Avatar" />
          </div>
          {/* <div className="container_div">
            <p className="bot_name">{botName}</p>
          </div> */}
        </button>
      );
    }
  };

  const getJson = () => {
    const href = `${window.origin}/range.json`;
    fetch(href)
      .then((res) => res.json())
      .then((data) => {
        setRange(data);
      })
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    getJson();
  }, []);

  const getRandomNumber = () => {
    return Math.random().toFixed(2);
  };

  useEffect(() => {
    const hidePage = getRandomNumber() < range.range && clientName === "dcf";
    setHidePopup(hidePage);
  }, [range, clientName]);

  const handleToggle = (status) => {
    if (status) {
      gaEventTracker(
        `Popup bubble clicked  for client ${clientName}`,
        window.location.href
      );
    }
  };

  return (
    !hidePopup &&
    clientName !== "neda" &&
    isBotOn && (
      <Main
        primaryColor={primaryColor}
        clientName={clientName}
        $loading={botLoading}
      >
        {greetingText?.length ? (
          <Widget
            title={botName}
            subtitle=""
            titleAvatar={botAvatar}
            showTimeStamp={false}
            senderPlaceHolder="Write a reply"
            launcher={(handleToggle) => getCustomLauncher(handleToggle)}
            handleNewUserMessage={handleNewUserMessage}
            showFooter={clientName !== "neda"}
            isLoading={botLoading}
            primaryColor={primaryColor}
          />
        ) : (
          <Widget
            title={botName}
            subtitle=""
            showTimeStamp={false}
            senderPlaceHolder="Write a reply"
            titleAvatar={botAvatar}
            handleToggle={handleToggle}
            //launcher={(handleToggle) => getCustomLauncher(handleToggle)}
            handleNewUserMessage={handleNewUserMessage}
            showFooter={clientName !== "neda"}
            isLoading={botLoading}
            primaryColor={primaryColor}
          />
        )}
      </Main>
    )
  );
};

export default Popup;

const Message = (props) => {
  const iframe = (url) => {
    return {
      __html: url,
    };
  };

  const renderButtons = (buttons) => {
    if (buttons?.length > 0) {
      return buttons?.map((button, index) => (
        <Button
          key={index}
          type="button"
          onClick={() => {
            addUserMessage(button.title);
            props.handleClick({
              personId: localStorage.getItem("hashId")
                ? localStorage.getItem("hashId")
                : localStorage.getItem("embedUserID"),
              personMessage: button.payload,
            });
          }}
        >
          {button.title}
        </Button>
      ));
    }
  };

  const renderLinks = () => {
    let urlLink = urlify(props?.message || "");
    let isImage = checkURL(urlLink);
    let isIframe = checkIframe(urlLink);

    if (isImage) {
      return (
        <img
          src={urlLink}
          alt="img"
          className="img img-responsive"
          width="200"
          height="200"
        />
      );
    } else if (isIframe && !isImage) {
      return <div dangerouslySetInnerHTML={iframe(props.message)} />;
    } else if (props?.message?.length > 0) {
      return (
        <Linkify
          properties={{ target: "_blank" }}
          componentDecorator={(decoratedHref, decoratedText, key) => (
            <a
              target="_blank"
              href={decoratedHref}
              key={key}
              rel="noopener noreferrer"
            >
              {decoratedText}
            </a>
          )}
        >
          {props.message}
        </Linkify>
      );
    }
  };

  return (
    <div className="rcw-message">
      <div className="rcw-response">
        <div className="rcw-message-text chat-message">
          {renderLinks()}
          <div>{renderButtons(props.buttons)}</div>
        </div>
      </div>
    </div>
  );
};
